import { render, staticRenderFns } from "./TabTranslationsWidget.vue?vue&type=template&id=5eaec6ce&"
import script from "./TabTranslationsWidget.vue?vue&type=script&lang=js&"
export * from "./TabTranslationsWidget.vue?vue&type=script&lang=js&"
import style0 from "./TabTranslationsWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports